import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import InstructorSection from "@/components/InstructorSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import SessionWalkthroughSection from "@/components/SessionWalkthroughSection";
import PricingSection from "@/components/PricingSection";
import PassesSection from "@/components/PassesSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MembershipPage from "@/components/MembershipPage";
import SpecialOffersPage from "@/components/SpecialOffersPage";
import BananaaaPage from "@/components/BananaaaPage";
import CheckinPage from "@/components/CheckinPage";
import TermsPage from "@/components/TermsPage";
import AboutPage from "@/components/AboutPage";
import PricingPage from "@/components/PricingPage";
import FeaturesPage from "@/components/FeaturesPage";

const HomePage = () => {
  const [contactInquiry, setContactInquiry] = useState("general");

  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "MyEnglish Lesson.ca | Practical English & Social Confidence Coaching";
    description?.setAttribute("content", "MyEnglish Lesson.ca by Tammam Mahdi — Practical, real-world Canadian English instruction for students across Canada and anywhere in the world preparing to call Canada home. Private class bundles, online group practice, and flexible pay-as-you-go lessons.");
    return () => {
      document.title = previousTitle;
      if (description) {
        if (previousDescription === null || previousDescription === undefined) description.removeAttribute("content");
        else description.setAttribute("content", previousDescription);
      }
    };
  }, []);

  const scrollToBookings = () => {
    document.getElementById("booking-section")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const openInquiry = (inquiryType) => {
    setContactInquiry(inquiryType);
    window.setTimeout(() => {
      document.getElementById("contact-section")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 40);
  };

  return (
    <div className="site-shell" id="top">
      <a className="skip-link" href="#main-content" data-testid="skip-to-content-link">Skip to content</a>
      <Header onBook={scrollToBookings} />
      <main id="main-content">
        <Hero onBook={scrollToBookings} />
        <section className="marquee-band" aria-label="What makes the lessons different">
          <div className="marquee-window"><div className="marquee-track">
            <span>Canadian English, made practical</span><span aria-hidden="true">✦</span><span>Confidence for real conversations</span><span aria-hidden="true">✦</span><span>Live practice. Warm guidance. Clear progress.</span><span aria-hidden="true">✦</span><span>Canadian English, made practical</span><span aria-hidden="true">✦</span><span>Confidence for real conversations</span><span aria-hidden="true">✦</span><span>Live practice. Warm guidance. Clear progress.</span><span aria-hidden="true">✦</span>
          </div></div>
        </section>
        <TestimonialsSection />
        <SessionWalkthroughSection />
        <InstructorSection />
        <PricingSection />
        <PassesSection onClassPass={() => openInquiry("class_pass")} />
        <FAQSection />
        <ContactSection selectedInquiry={contactInquiry} />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
};

const App = () => {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  return pathname === "/membership" ? <MembershipPage /> : pathname === "/special-offers" ? <SpecialOffersPage /> : pathname === "/bananaaa" ? <BananaaaPage /> : pathname === "/checkin" ? <CheckinPage /> : pathname === "/terms" ? <TermsPage /> : pathname === "/about" ? <AboutPage /> : pathname === "/pricing" ? <PricingPage /> : pathname === "/features" ? <FeaturesPage /> : <HomePage />;
};

export default App;
